import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';
import { resolveSafeReturnUrl } from '../../shared/utils/safe-return-url';

@Injectable({
  providedIn: 'root',
})
export class GuestGuard implements CanActivate {
  public constructor(
    private readonly authService: AuthService,
    private readonly router: Router
  ) {}

  public canActivate(
    route: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot
  ): Observable<boolean> {
    if (!this.authService.isAuthenticated()) {
      return of(true);
    }

    const returnUrlParam = route.queryParamMap.get('returnUrl');
    const target = resolveSafeReturnUrl(returnUrlParam);

    return this.authService.validateSession().pipe(
      map(() => {
        void this.router.navigateByUrl(target);
        return false;
      }),
      catchError(() => {
        this.authService.logout();
        return of(true);
      })
    );
  }
}
